export const VERSION = {
  major: 0,
  minor: 16,
  patch: 4,
  // Format: vMAJOR.MINOR.PATCH
  toString: function() {
    return `v${this.major}.${this.minor}.${this.patch}`;
  }
}; 